import React, { useRef } from 'react';
import { BiFilterAlt } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Flex, HStack,
  Icon,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverTrigger,
  Portal,
  useDisclosure
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import SearchBlueprintType from '../../../types/SearchBlueprintType';
import { closeOpenedQuickFilterInputs } from '../../../utils/quickFiltersUtil';
import SearchAdvancedFilters from '../SearchAdvancedFilters';
import SearchQuickFilters from '../SearchQuickFilters';

const SearchFilters = ({
  variant,
  searchBlueprint,
  dataAnalyticsId,
  onPopoverClose = () => {},
  onReset = () => {},
  popoverPlacement = 'left'
}) => {
  const dispatch = useDispatch();
  const quickFilters = useSelector(searchBlueprint.selectQuickFilterOptions);
  const focusRef = useRef();
  const { onOpen, onClose, isOpen } = useDisclosure();
  const totalFilterCount = useSelector(searchBlueprint.selectAppliedFilterCount);

  return (
    <Popover
      closeOnBlur={false}
      initialFocusRef={focusRef}
      isOpen={isOpen}
      placement={popoverPlacement}
      onClose={() => {
        onClose();
        onPopoverClose();
      }}
      onOpen={onOpen}
    >
      <PopoverTrigger>
        <HStack
          alignItems="flex-start"
          spacing={0}
        >
          <IconButton
            aria-label="Filters"
            data-analytics-id={dataAnalyticsId}
            icon={<Icon as={BiFilterAlt} h={6} w={6} />}
            variant={variant}
          />
          {totalFilterCount > 0 && (
            <Box
              alignItems="center"
              backgroundColor="primaryScale.600"
              borderRadius="50%"
              color="white"
              fontSize="10px"
              h="15px"
              justifyContent="center"
              w="15px"
            >
              {totalFilterCount}
            </Box>
          )}
        </HStack>
      </PopoverTrigger>
      <Portal>
        <PopoverContent p={8}>
          <PopoverArrow />
          <PopoverCloseButton _focus={{ outline: 'none' }} />
          <PopoverBody p={0}>
            <SearchQuickFilters searchBlueprint={searchBlueprint} />
            <SearchAdvancedFilters searchBlueprint={searchBlueprint} />
          </PopoverBody>
          <PopoverFooter>
            <Flex mt={8}>
              <Button
                ml="auto"
                variant="secondary"
                onClick={() => {
                  dispatch(searchBlueprint.resetFilters());
                  onReset();
                }}
              >
                Reset Filters
              </Button>
              <Button
                ml={4}
                ref={focusRef}
                variant="primary"
                onClick={() => {
                  dispatch(searchBlueprint.applyFilters());
                  onClose();
                  // close any filters that were left open
                  closeOpenedQuickFilterInputs(quickFilters);
                }}
              >
                Show Results
              </Button>
            </Flex>
          </PopoverFooter>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

SearchFilters.propTypes = {
  searchBlueprint: SearchBlueprintType,
  variant: PropTypes.string,
  dataAnalyticsId: PropTypes.string,
  onPopoverClose: PropTypes.func,
  onReset: PropTypes.func,
  popoverPlacement: PropTypes.string
};

export default SearchFilters;
